import {
  EmploymentStatus,
  EmploymentStatusLabel,
} from "@/models/employment-info.model";
import { StatusColors } from "@/utils/status-colours";
import React from "react";

interface Props {
  status: EmploymentStatus;
}

function EmploymentStatusTag({ status }: Props) {
  const colors = StatusColors[status];

  if (!colors) {
    return (
      <div
        className={`bg-red-100 text-red-400
        flex pt-2 pb-2 pl-3 pr-3 rounded-xl font-semibold justify-center items-center w-max text-xs`}
      >
        Not yet Onboarded
      </div>
    )
  }
  return (
    <div
      className={`${colors.bg} ${colors.text}
        flex pt-2 pb-2 pl-3 pr-3 rounded-xl font-semibold justify-center items-center w-max text-xs`}
    >
      {EmploymentStatusLabel[status]}
    </div>
  );
}

export default EmploymentStatusTag;
